import React, {useRef, useEffect} from "react";
import gsap from "gsap";

import styles from "./States.module.scss";

export default function States() {
    const svg = `
<svg width="887px" height="652px" viewBox="0 0 887 652" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-5.000000, 0.000000)">
            <g transform="translate(74.000000, 128.000000)">
                <polygon fill="#E8BF17" class="state-yellow" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="22.8554688" y="45">WA</tspan>
                </text>
            </g>
            <g transform="translate(148.000000, 128.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.9833984" y="45">MT</tspan>
                </text>
            </g>
            <g>
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.2875977" y="45">AK</tspan>
                </text>
            </g>
            <g transform="translate(222.000000, 128.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.6879883" y="45">ND</tspan>
                </text>
            </g>
            <g transform="translate(296.000000, 128.000000)">
                <polygon fill="#E8BF17" class="state-yellow" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="21.7758789" y="45">MN</tspan>
                </text>
            </g>
            <g transform="translate(370.000000, 128.000000)">
                <polygon fill="#E8BF17" class="state-yellow" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.7495117" y="45">WI</tspan>
                </text>
            </g>
            <g transform="translate(111.000000, 192.000000)">
                <polygon fill="#56A51C" class="state-green" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="28.9140625" y="45">ID</tspan>
                </text>
            </g>
            <g transform="translate(185.000000, 192.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.6557617" y="45">WY</tspan>
                </text>
            </g>
            <g transform="translate(259.000000, 192.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.9438477" y="45">SD</tspan>
                </text>
            </g>
            <g transform="translate(333.000000, 192.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="29.972168" y="45">IA</tspan>
                </text>
            </g>
            <g transform="translate(407.000000, 192.000000)">
                <polygon fill="#E8BF17" class="state-yellow" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="31.2236328" y="45">IL</tspan>
                </text>
            </g>
            <g transform="translate(74.000000, 256.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="24.6333008" y="45">OR</tspan>
                </text>
            </g>
            <g transform="translate(148.000000, 256.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.159668" y="45">NV</tspan>
                </text>
            </g>
            <g transform="translate(222.000000, 256.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="24.4936523" y="45">CO</tspan>
                </text>
            </g>
            <g transform="translate(296.000000, 256.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.5893555" y="45">NE</tspan>
                </text>
            </g>
            <g transform="translate(370.000000, 256.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="21.5019531" y="45">MO</tspan>
                </text>
            </g>
            <g transform="translate(111.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.0996094" y="45">CA</tspan>
                </text>
            </g>
            <g transform="translate(185.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.90625" y="45">UT</tspan>
                </text>
            </g>
            <g transform="translate(259.000000, 320.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="21.7758789" y="45">NM</tspan>
                </text>
            </g>
            <g transform="translate(333.000000, 320.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.2114258" y="45">KS</tspan>
                </text>
            </g>
            <g transform="translate(407.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.2392578" y="45">AR</tspan>
                </text>
            </g>
            <g transform="translate(445.000000, 256.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.0878906" y="45">KY</tspan>
                </text>
            </g>
            <g transform="translate(519.000000, 256.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.269043" y="45">WV</tspan>
                </text>
            </g>
            <g transform="translate(593.000000, 256.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.4916992" y="45">VA</tspan>
                </text>
            </g>
            <g transform="translate(667.000000, 256.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="22.0498047" y="45">MD</tspan>
                </text>
            </g>
            <g transform="translate(741.000000, 256.000000)">
                <polygon fill="#56A51C" class="state-green" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.8632812" y="45">DE</tspan>
                </text>
            </g>
            <g transform="translate(482.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.621582" y="45">TN</tspan>
                </text>
            </g>
            <g transform="translate(222.000000, 384.000000)">
                <polygon fill="#56A51C" class="state-green" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.7602539" y="45">AZ</tspan>
                </text>
            </g>
            <g transform="translate(0.000000, 512.000000)">
                <polygon fill="#56A51C" class="state-green" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="28.8173828" y="45">HI</tspan>
                </text>
            </g>
            <g transform="translate(296.000000, 384.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="24.6816406" y="45">OK</tspan>
                </text>
            </g>
            <g transform="translate(333.000000, 448.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.565918" y="45">TX</tspan>
                </text>
            </g>
            <g transform="translate(370.000000, 384.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.3295898" y="45">LA</tspan>
                </text>
            </g>
            <g transform="translate(444.000000, 384.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="24.0317383" y="45">MS</tspan>
                </text>
            </g>
            <g transform="translate(518.000000, 384.000000)">
                <polygon fill="#304A7D" class="state-blue" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.3295898" y="45">AL</tspan>
                </text>
            </g>
            <g transform="translate(555.000000, 448.000000)">
                <polygon fill="#304A7D" class="state-blue" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="28.6132812" y="45">FL</tspan>
                </text>
            </g>
            <g transform="translate(593.000000, 384.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.0307617" y="45">GA</tspan>
                </text>
            </g>
            <g transform="translate(370.000000, 572.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.0019531" y="45">AS</tspan>
                </text>
            </g>
            <g transform="translate(444.000000, 572.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.9833984" y="45">GU</tspan>
                </text>
            </g>
            <g transform="translate(518.000000, 572.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.4462891" y="45">MP</tspan>
                </text>
            </g>
            <g transform="translate(592.000000, 572.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="30.3857422" y="45">VI</tspan>
                </text>
            </g>
            <g transform="translate(667.000000, 572.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.5776367" y="45">PR</tspan>
                </text>
            </g>
            <g transform="translate(556.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="24.7675781" y="45">NC</tspan>
                </text>
            </g>
            <g transform="translate(630.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.0234375" y="45">SC</tspan>
                </text>
            </g>
            <g transform="translate(704.000000, 320.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.0415039" y="45">DC</tspan>
                </text>
            </g>
            <g transform="translate(668.000000, 128.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="25.5463867" y="45">NY</tspan>
                </text>
            </g>
            <g transform="translate(742.000000, 128.000000)">
                <polygon fill="#56A51C" class="state-green" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.1079102" y="45">MA</tspan>
                </text>
            </g>
            <g transform="translate(705.000000, 64.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.3671875" y="45">VT</tspan>
                </text>
            </g>
            <g transform="translate(779.000000, 64.000000)">
                <polygon fill="#304A7D" class="state-blue" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.5913086" y="45">NH</tspan>
                </text>
            </g>
            <g transform="translate(816.000000, 0.000000)">
                <polygon fill="#E8BF17" class="state-yellow" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.9511719" y="45">ME</tspan>
                </text>
            </g>
            <g transform="translate(631.000000, 192.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.4165039" y="45">PA</tspan>
                </text>
            </g>
            <g transform="translate(705.000000, 192.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="28.769043" y="45">NJ</tspan>
                </text>
            </g>
            <g transform="translate(779.000000, 192.000000)">
                <polygon fill="#304A7D" class="state-blue" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="26.9750977" y="45">CT</tspan>
                </text>
            </g>
            <g transform="translate(816.000000, 128.000000)">
                <polygon fill="#9B9B9B" class="state-grey" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="30.1333008" y="45">RI</tspan>
                </text>
            </g>
            <g transform="translate(519.000000, 128.000000)">
                <polygon fill="#304A7D" class="state-blue" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="27.0019531" y="45">MI</tspan>
                </text>
            </g>
            <g transform="translate(482.000000, 192.000000)">
                <polygon fill="#304A7D" class="state-blue" points="40.5 0 75.1410162 20 75.1410162 60 40.5 80 5.85898385 60 5.85898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="28.6401367" y="45">IN</tspan>
                </text>
            </g>
            <g transform="translate(556.000000, 192.000000)">
                <polygon fill="#56A51C" class="state-green" points="41 0 75.6410162 20 75.6410162 60 41 80 6.35898385 60 6.35898385 20"/>
                <text font-family="OpenSans-Regular, Open Sans" font-size="22" font-weight="normal" fill="#FFFFFF">
                    <tspan x="23.3173828" y="45">OH</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;
    return (
        <div className={styles.Main} dangerouslySetInnerHTML={{__html: svg}}/>
    )
}

const legendPoint = (color) => {
    const style = window.getComputedStyle(document.querySelector('body'));

    const svg = `<svg width="26px" height="30px" viewBox="0 0 26 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon fill="${style.getPropertyValue(`--${color}`)}" points="13 0 25.9903811 7.5 25.9903811 22.5 13 30 0.00961894323 22.5 0.00961894323 7.5"/>
        </g>
    </svg>`;

    return svg;

}

export function Legend() {
    const legend = useRef(null);

    const highlightPolygone = (classname) => {
        const related = document.getElementsByClassName(classname);

        gsap.to(`[class*=state-]`, .3, {
            opacity: .3
        });

        gsap.to(related, .3, {
            opacity: 1
        });

    }

    useEffect(() => {
        Object.values(legend.current.querySelectorAll('li')).map(item =>
            item.addEventListener('click', () =>
                highlightPolygone(`state-${item.id.replace('legend-', '')}`)
            )
        );

        Object.values(document.querySelectorAll('[class*=state-]')).map(item => {
            item.closest('g').addEventListener('mouseenter', () =>
                highlightPolygone(item.classList[0])
            );

            item.closest('svg').addEventListener('mouseleave', () => {
                gsap.to(`[class*=state-]`, .3, {
                    opacity: 1
                });
            })

            return true;
        });

        window.addEventListener('scroll', () => {
            gsap.to(`[class*=state-]`, .3, {
                opacity: 1
            });
        }, {passive: true})
    }, []);

    return (
        <ul className={styles.Legend} ref={legend}>
            <li id={'legend-blue'}>
                <i dangerouslySetInnerHTML={{__html: legendPoint('blue1') }}/>
                Législation promulguée
            </li>

            <li id={'legend-green'}>
                <i dangerouslySetInnerHTML={{__html: legendPoint('green4') }}/>
                Décret présidentiel
            </li>

            <li id={'legend-yellow'}>
                <i dangerouslySetInnerHTML={{__html: legendPoint('yellow1') }}/>
                Les deux
            </li>

            <li id={'legend-grey'}>
                <i dangerouslySetInnerHTML={{__html: legendPoint('grey2') }}/>
                Aucun des deux
            </li>
        </ul>
    )
}
